export default "__VITE_ASSET__f3VHzHX4__"